import type { ReactNode } from 'react';

export interface SuggestedQuestion {
  label: ReactNode;
  value: string;
}

interface SuggestedQuestionsProps {
  questions: SuggestedQuestion[];
  onSelect: (value: string) => void;
  disabled?: boolean;
  ariaLabel: string;
  variant?: 'default' | 'welcome';
}

/**
 * The single visual and interaction component for question chips. It is used on
 * the welcome screen and for native Constructor refinements so both contexts
 * inherit identical layout, states, focus treatment, and responsive behaviour.
 */
export function SuggestedQuestions({questions, onSelect, disabled = false, ariaLabel, variant = 'default'}: SuggestedQuestionsProps) {
  return <div className={`twe-drinks-advisor__starters${variant === 'welcome' ? ' twe-drinks-advisor__starters--welcome' : ''}`} role="group" aria-label={ariaLabel}>
    {questions.map((question, index) => <button
      type="button"
      key={`${question.value}-${index}`}
      className="twe-drinks-advisor__suggestion-tag"
      disabled={disabled}
      onClick={() => onSelect(question.value)}
    ><span>{question.label}</span></button>)}
  </div>;
}
